<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove this rule ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmAkpr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      akpr_encrid: null,
      akpr: {}
    }
  },
  methods: {
    open(akpr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/getAkpr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getAkpr"
          },
          getAkpr: {
            akpr_encrid: akpr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.akpr = res.data.getAkpr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmAkpr() { 
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/rmAkpr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmAkpr"
          },
          rmAkpr: {
            akpr_encrid: this.akpr.akpr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/syst/ref/akcd/searchAkcd/'); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmAkpr.text,
              color: res.data.rmAkpr.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

